import { render, staticRenderFns } from "./RootCA.vue?vue&type=template&id=cc73ca9c&scoped=true&"
import script from "./RootCA.vue?vue&type=script&lang=js&"
export * from "./RootCA.vue?vue&type=script&lang=js&"
import style0 from "./RootCA.vue?vue&type=style&index=0&id=cc73ca9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc73ca9c",
  null
  
)

export default component.exports